<script lang="ts">
    import lang from '../../lang/language';
    import type { ServiceType } from '../../store/types';
    import { formatMoney, getType } from '../../helpers/common';
    import AddToWishlistButton from '../../shared_components/AddToWishlistButton.svelte';
    import { getDetailsUrl, getLanguage } from '../../helpers/url';
    import { currentLangIsJapanese } from '../../helpers/url';
    // import { Link } from 'svelte-navigator';

    import { link } from 'svelte-spa-router';

    export let service: any;
</script>

<div class="col-md-4 mb-4">
    <div class="c-column__item mx-auto">
        <p class="c-tag-category" />
        <a href="javascript:void(0)">
            <div class="c-column__thumb">
                <figure>
                    <img src={service.Thumbnail} alt="" class="object-fit" />
                </figure>
            </div>
            <div class="c-column__text">
                <p class="c-column__date mb-3">{getType(service.Type)}</p>
                <p
                    class="c-column__title"
                    style="height: 50px; font-size: 1.5rem"
                >
                    {#if service.Name.length > 100}
                        {service.Name.substr(100)}
                    {:else}
                        {service.Name}
                    {/if}
                </p>
                <p
                    class="c-column__title font-weight-normal"
                    style="height: 50px; font-size: 1.5rem"
                >
                    {service.Address}
                </p>

                <p
                    class="c-column__title font-weight-normal"
                    style="font-size: 1.5rem"
                >
                    {#if service.Price}
                        {!currentLangIsJapanese() && service.Price > 0
                            ? lang.from
                            : ''}
                        ¥{formatMoney(service.Price)}
                        {currentLangIsJapanese() && service.Price > 0
                            ? lang.from
                            : ''}
                    {/if}
                </p>
                <p
                    class="c-column__title font-weight-normal info desc"
                    style="font-size: 1.2rem"
                >
                    {service.Desc}
                </p>
            </div>
            <a
                href="?lang={getLanguage()}&page=details&id={service.Id}&on_req={service.OnRequestOnly}"
                class=""
            >
                <p class="c-column__morelink">{lang.view_details}</p>
            </a>
        </a>
    </div>
</div>

<!-- <div class="card-wrapper">
    <div class="thumb-wrapper">
        <img
            src={service.Thumbnail}
            alt="service thumbnail"
            class=" background-animate"
        />
    </div>
    <h4 class="info name">{service.Name}</h4>

    <div class="info address">{service.Address}</div>

    <div class="info price">
        {#if service.Price}
            {!currentLangIsJapanese() && service.Price > 0 ? lang.from : ''}
            ¥{formatMoney(service.Price)}
            {currentLangIsJapanese() && service.Price > 0 ? lang.from : ''}
        {/if}
    </div>
    <div class="info desc">
        {@html service.Desc}
    </div>
    <div class="col-button">

        <a
            href="?lang={getLanguage()}&page=details&id={service.Id}&on_req={service.OnRequestOnly}"
            class="second-button flex-1  bordered font nara-season"
        >
            {lang.view_details}
        </a>
    </div>
</div> -->
<style>
    .full-width {
        width: 100%;
    }

    .c-column__title::before {
        content: '';
        display: none;
    }
    .c-column__title {
        margin: 0;
        padding: 0;
    }

    :global(.card-wrapper) {
        background-color: transparent;
        padding: 5px;
        display: flex;
        flex-direction: column;
        margin-bottom: 40px;
        position: relative;
        background-color: rgba(255, 255, 255, 0.15);
        backdrop-filter: blur(5px);
    }

    :global(.thumb-wrapper) > :global(img) {
        background-color: black;
        height: 100%;
        width: 100%;
        object-fit: cover;
    }

    :global(.thumb-wrapper) {
        border: 1px solid lightgray;
        width: 100%;
        height: 200px;
    }

    :global(.thumb-wrapper.children) {
        border: 1px solid lightgray;
        width: 100%;
        height: 100%;
    }

    :global(.info) {
        margin: 5px 0px;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        overflow: hidden;
        height: 20px;
        line-height: 20px;
        color: black;
        text-align: left;
    }

    :global(.info.name) {
        font-weight: bold;
    }

    :global(.info.desc) {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
        height: 60px;
        line-height: 20px;
        position: relative;
    }

    :global(.info.desc.children) {
        -webkit-line-clamp: inherit;
        height: auto;
    }

    :global(.info.address) {
        background-image: url('../icons/pin.png');
        background-size: 15px;
        background-position: left center;
        padding-left: 15px;
        background-repeat: no-repeat;
    }
    :global(.info.address) {
        background-image: url('../icons/rating.png');
        background-size: 15px;
        background-position: left center;
        padding-left: 15px;
        background-repeat: no-repeat;
    }

    :global(.row-button) {
        display: flex;
        width: 100%;
        text-align: center;
        overflow: hidden;
        height: auto;
        padding: 20px 10px;
    }

    :global(.col-button) {
        display: flex;
        flex-direction: column;
        gap: 5px;
        width: 100%;
        text-align: center;
        overflow: hidden;
        height: auto;
        padding: 20px 10px;
    }

    :global(.card-wrapper) a {
        text-decoration: none;
        font-weight: bold;
    }

    :global(.like-button-wrapper) {
        position: absolute;
        top: 15px;
        right: 10px;
    }
</style>
